
import { mainStore } from "../store"
import { __ } from "../utils"
import TextCenter from './textCenter.jsx'



export default function Outro(props) {

    /**
     * Setup
     */
    const colors = mainStore.useStore(s => s.colors)
    const fonts = mainStore.useStore(s => s.fonts)




    return <group position={[0, -137.6, 0]}>
        <TextCenter
            maxWidth={1.8}
            fontsOw={fonts.ms.text}
            fontSize={0.062}
            lineHeight={1.4}
            exposantHeight={0.05}
            positionY={-.38}
            scale={1}
            offsetX={-0.43}
            offsetY={-0.4}>
            {
                __("L’histoire de SILAB continue de s’écrire chaque jour…", "The SILAB's story continues to be written every day...")
            }
        </TextCenter>
        <TextCenter
            maxWidth={1.8}
            fontsOw={fonts.ms.text}
            fontSize={0.062}
            lineHeight={1.4}
            exposantHeight={0.05}
            positionY={-.55}
            scale={1}
            offsetX={-0.43}
            offsetY={-0.4}>
            {
                __("Consultez régulièrement cette rubrique pour découvrir la suite de l’aventure !", "Check back regularly to find out what's next!")
            }
        </TextCenter>
    </group>
}